type FormItemProps = {
	children: React.ReactNode
	label: string
	error: string | undefined
	isRequired?: boolean
}

export function FormItem({
	children,
	label,
	error,
	isRequired = true,
}: FormItemProps) {
	return (
		<div className="space-y-2">
			<label className="text-sm font-medium">
				{label}
				{isRequired && <span className="text-red-500"> *</span>}
			</label>
			{children}
			<p className="text-sm text-red-500">{error}</p>
		</div>
	)
}
